import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { ToastNotificationComponent } from '../components/components/toast-notification/toast-notification.component';

export interface ToastConfig {
    big?: boolean;
    duration?: number;
    actionText?: string;
    action?: () => any;
}

export type ToastType = 'success' | 'error' | 'warning' | 'info' | 'neutral';

@Injectable({
    providedIn: 'root',
})
export class ToastService {
    constructor(private snackBar: MatSnackBar) {}

    public static getClassBasedOnToastType(toastType: ToastType): string {
        switch (toastType) {
            case 'success':
                return 'toast-success';
            case 'error':
                return 'toast-error';
            case 'warning':
                return 'toast-warning';
            case 'info':
                return 'toast-informative';
            case 'neutral':
            default:
                return 'toast-neutral';
        }
    }

    public showSuccess(message: string, config?: ToastConfig): void {
        this.showToast('success', message, config);
    }

    public showError(message: string, config?: ToastConfig): void {
        this.showToast('error', message, config);
    }

    private showToast(toastType: ToastType, message: string, config?: ToastConfig): void {
        const toastConfig = {
            horizontalPosition: 'end',
            verticalPosition: 'bottom',
            panelClass: [ToastService.getClassBasedOnToastType(toastType)],
            data: {
                toastType,
                message,
            },
        } as MatSnackBarConfig;

        if (config) {
            Object.assign(toastConfig.data, config);
            toastConfig.duration = config.duration;
        }

        toastConfig.panelClass = [ToastService.getClassBasedOnToastType(toastType)];
        if (toastConfig.data.big) {
            toastConfig.panelClass.push('big-toast');
        }

        this.snackBar.openFromComponent(ToastNotificationComponent, toastConfig);
    }
}
